
export const translations = {
  fr: {
    // Header
    search: "Rechercher des produits...",
    categories: "Catégories",
    cart: "Panier",
    profile: "Profil",
    signin: "Se connecter",
    language: "Langue",
    
    // Navigation Categories
    food_drinks: "Aliments et Boissons",
    sports_articles: "Articles Sportifs", 
    handicrafts: "Artisanat et Produits Faits Main",
    electronics: "Électroniques",
    professional_equipment: "Équipements Professionnels",
    toys: "Jouets pour Enfants",
    home_garden: "Maison & Jardinage",
    medical_equipment: "Matériel Médical",
    beauty_care: "Produits de Beauté et Soins Personnels",
    services: "Services",
    clothing_accessories: "Vêtements et Accessoires",
    travel_tickets: "Voyages et Billets",
    
    // Homepage
    welcome: "Bienvenue sur Nengoo",
    subtitle: "Votre marketplace camerounaise de confiance",
    featuredProducts: "Produits en Vedette",
    newArrivals: "Nouvelles Arrivées",
    bestSellers: "Meilleures Ventes",
    localSpecialties: "Spécialités Locales",
    flashSale: "Vente Flash",
    viewAll: "Voir tout",
    
    // Product
    addToCart: "Ajouter au Panier",
    buyNow: "Acheter Maintenant",
    inStock: "En Stock",
    availableColors: "Couleurs disponibles",
    productDetails: "Caractéristiques",
    brand: "Marque",
    condition: "État",
    conditions: { new: "Neuf", used: "Occasion", refurbished: "Reconditionné" },
    outOfStock: "Rupture de Stock",
    reviews: "Avis",
    rating: "Note",
    specifications: "Spécifications",
    description: "Description",
    
    // Cart
    shoppingCart: "Panier d'Achat",
    quantity: "Quantité",
    price: "Prix",
    total: "Total",
    subtotal: "Sous-total",
    shipping: "Livraison",
    checkout: "Commander",
    continueShipping: "Continuer les Achats",
    removeItem: "Supprimer",
    emptyCart: "Votre panier est vide",
    
    // Checkout
    billingInfo: "Informations de Facturation",
    shippingInfo: "Informations de Livraison",
    paymentMethod: "Méthode de Paiement",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    city: "Ville",
    region: "Région",
    postalCode: "Code Postal",
    mtnMoney: "MTN Mobile Money",
    orangeMoney: "Orange Money",
    creditCard: "Carte de Crédit",
    cashOnDelivery: "Paiement à la Livraison",
    placeOrder: "Passer Commande",
    yourDetails: "Vos coordonnées",
    fullName: "Nom",
    phoneHint: "Le vendeur vous appellera ou vous écrira sur WhatsApp à ce numéro.",
    emailOptional: "E-mail (facultatif)",
    neighborhood: "Quartier",
    landmark: "Point de repère",
    landmarkHint: "Ex. : face à la pharmacie, derrière l'école…",
    addressOptional: "Adresse (facultatif)",
    orderPlaced: "Commande enregistrée",
    orderPlacedText: (n) => n > 1 ? `Vos ${n} commandes ont été transmises aux vendeurs.` : "Votre commande a été transmise au vendeur.",
    orderNumber: "Numéro de commande",
    orderNextStep: "Le vendeur va vous contacter pour confirmer. Gardez ce numéro pour suivre votre commande.",
    trackOrder: "Suivre ma commande",
    trackOrderTitle: "Suivi de commande",
    trackOrderIntro: "Entrez le numéro de commande et le téléphone utilisé pour commander. Aucun compte n'est nécessaire.",
    trackButton: "Voir ma commande",
    orderNotFound: "Aucune commande ne correspond à ce numéro et à ce téléphone.",
    orderedOn: "Commandée le",
    continueShopping: "Continuer mes achats",
    deliveryCode: "Code de livraison",
    deliveryCodeHint: "À donner au livreur quand il vous remet le colis",
    
    // Footer
    about: "À Propos",
    contact: "Contact",
    help: "Aide",
    terms: "Conditions",
    privacy: "Confidentialité",
    followUs: "Suivez-nous",
    newsletter: "Newsletter",
    subscribe: "S'abonner",
    footerText: "Nengoo - Votre marketplace camerounaise de confiance depuis 2025",
    
    // Authentication
    login: "Se connecter",
    signup: "S'inscrire",
    loginAsBuyer: "Se connecter en tant qu'acheteur",
    loginAsSeller: "Se connecter en tant que vendeur",
    buyerLogin: "Connexion acheteur",
    sellerLogin: "Connexion vendeur",
    whatsappNumber: "Numéro WhatsApp",
    enterWhatsApp: "Entrez votre numéro WhatsApp",
    selectCategories: "Sélectionner les catégories",
    businessName: "Nom de l'entreprise",
    selectCity: "Choisir votre ville",
    signupAsSeller: "Inscription vendeur",
    signupAsBuyer: "Inscription acheteur",
    createAccount: "Créer un compte",
    haveAccount: "Déjà un compte ?",
    noAccount: "Pas de compte ?",
pendingApproval: "En attente d'approbation",
    approvalMessage: "Votre demande d'inscription en tant que vendeur a été soumise. Vous recevrez une confirmation par WhatsApp une fois votre compte approuvé par l'administrateur.",
    backToHome: "Retour à l'accueil",
    logout: "Se déconnecter",
    welcomeBack: "Bon retour",

    // Homepage (refonte)
    heroTitle: "Les vendeurs du Cameroun, réunis sur un seul marché",
    heroText: "Parcourez leurs produits, ajoutez-les au panier ou écrivez directement au vendeur sur WhatsApp.",
    browseCatalog: "Voir le catalogue",
    pickupPoints: "Points de retrait",
    shopByCategory: "Parcourir par catégorie",
    allProducts: "Tous les produits",
    productCount: (n) => `${n} produit${n > 1 ? 's' : ''}`,
    newBadge: "Nouveau",
    whatsappSeller: "WhatsApp",
    privacyPolicy: "Politique de confidentialité",
    deleteAccount: "Supprimer mon compte",
    rightsReserved: "Tous droits réservés.",
    noProducts: "Aucun produit pour le moment",
    noProductsText: "Les vendeurs ajoutent leurs articles. Revenez bientôt ou parcourez le catalogue.",
    loadingProducts: "Chargement des produits…",

    // Catalogue
    catalogTitle: "Catalogue",
    allCategories: "Toutes",
    subcategories: "Sous-catégories",
    allOf: (name) => `Tout ${name}`,
    filters: "Filtres",
    sortLabel: "Trier par",
    sortRecent: "Plus récents",
    sortName: "Nom (A → Z)",
    sortPriceLow: "Prix croissant",
    sortPriceHigh: "Prix décroissant",
    maxPrice: "Prix maximum",
    upTo: (p) => `Jusqu'à ${p}`,
    resetFilters: "Réinitialiser les filtres",
    noMatch: "Aucun produit ne correspond à ces filtres",
    noMatchText: "Augmentez le prix maximum ou choisissez une autre catégorie.",
    loadError: "Impossible de charger les produits. Vérifiez votre connexion, puis réessayez.",
    retry: "Réessayer",

    // Points de retrait
    pickupIntro: "Faites livrer votre commande dans un point de retrait près de chez vous, puis récupérez-la pendant ses horaires d'ouverture.",
    howItWorks: "Comment ça marche",
    pickupSteps: [
      "Choisissez un point de retrait au moment de commander.",
      "Le vendeur dépose votre article dans ce point.",
      "Vous êtes prévenu dès que le colis est arrivé.",
      "Passez le récupérer pendant les horaires d'ouverture."
    ],
    allCities: "Toutes les villes",
    managedBy: (n) => `Géré par ${n}`,
    call: "Appeler",
    directions: "Itinéraire",
    pickupCount: (n) => `${n} point${n > 1 ? 's' : ''} de retrait`,
    pickupEmpty: "Aucun point de retrait pour le moment",
    pickupEmptyText: "Les points de retrait seront bientôt disponibles. En attendant, choisissez la livraison à domicile au moment de commander.",
    pickupError: "Impossible de charger les points de retrait. Vérifiez votre connexion, puis réessayez.",
    
    // Fiche produit
    soldBy: "Vendu par",
    contactWhatsApp: "Contacter sur WhatsApp",
    sendMessage: "Envoyer un message",
    messageTo: (n) => `Écrire à ${n}`,
    messagePlaceholder: "Votre message au vendeur…",
    cancel: "Annuler",
    send: "Envoyer",
    share: "Partager",
    reviewsTitle: "Avis des clients",
    reviewsCount: (n) => `${n} avis`,
    noReviews: "Pas encore d'avis sur ce produit.",
    leaveReview: "Donner votre avis",
    yourRating: "Votre note",
    yourComment: "Votre commentaire",
    submitReview: "Publier l'avis",
    alreadyReviewed: "Vous avez déjà donné votre avis sur ce produit.",
    relatedProducts: "Dans la même catégorie",
    productNotFound: "Ce produit n'existe pas ou n'est plus en vente",
    productNotFoundText: "Il a peut-être été retiré par le vendeur. Parcourez le catalogue pour trouver un article similaire.",
    photoOf: (i) => `Photo ${i}`,
    zoomPhoto: "Agrandir la photo"
  },
  en: {
    // Header
    search: "Search products...",
    categories: "Categories",
    cart: "Cart",
    profile: "Profile",
    signin: "Sign In",
    language: "Language",
    
    // Navigation Categories
    food_drinks: "Food & Drinks",
    sports_articles: "Sports Articles", 
    handicrafts: "Handicrafts & Handmade",
    electronics: "Electronics",
    professional_equipment: "Professional Equipment",
    toys: "Children's Toys",
    home_garden: "Home & Garden",
    medical_equipment: "Medical Equipment",
    beauty_care: "Beauty & Personal Care",
    services: "Services",
    clothing_accessories: "Clothing & Accessories",
    travel_tickets: "Travel & Tickets",
    
    // Homepage
    welcome: "Welcome to Nengoo",
    subtitle: "Your trusted Cameroonian marketplace",
    featuredProducts: "Featured Products",
    newArrivals: "New Arrivals",
    bestSellers: "Best Sellers",
    localSpecialties: "Local Specialties",
    flashSale: "Flash Sale",
    viewAll: "View All",
    
    // Product
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    inStock: "In Stock",
    availableColors: "Available colours",
    productDetails: "Details",
    brand: "Brand",
    condition: "Condition",
    conditions: { new: "New", used: "Used", refurbished: "Refurbished" },
    outOfStock: "Out of Stock",
    reviews: "Reviews",
    rating: "Rating",
    specifications: "Specifications",
    description: "Description",
    
    // Cart
    shoppingCart: "Shopping Cart",
    quantity: "Quantity",
    price: "Price",
    total: "Total",
    subtotal: "Subtotal",
    shipping: "Shipping",
    checkout: "Checkout",
    continueShipping: "Continue Shopping",
    removeItem: "Remove",
    emptyCart: "Your cart is empty",
    
    // Checkout
    billingInfo: "Billing Information",
    shippingInfo: "Shipping Information",
    paymentMethod: "Payment Method",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
phone: "Phone",
    address: "Address",
    city: "City",
    region: "Region",
    postalCode: "Postal Code",
    mtnMoney: "MTN Mobile Money",
    orangeMoney: "Orange Money",
    creditCard: "Credit Card",
    cashOnDelivery: "Cash on Delivery",
    placeOrder: "Place Order",
    yourDetails: "Your details",
    fullName: "Name",
    phoneHint: "The seller will call you or message you on WhatsApp at this number.",
    emailOptional: "Email (optional)",
    neighborhood: "Neighbourhood",
    landmark: "Landmark",
    landmarkHint: "E.g. opposite the pharmacy, behind the school…",
    addressOptional: "Address (optional)",
    orderPlaced: "Order placed",
    orderPlacedText: (n) => n > 1 ? `Your ${n} orders have been sent to the sellers.` : "Your order has been sent to the seller.",
    orderNumber: "Order number",
    orderNextStep: "The seller will contact you to confirm. Keep this number to track your order.",
    trackOrder: "Track my order",
    trackOrderTitle: "Order tracking",
    trackOrderIntro: "Enter your order number and the phone number used to order. No account needed.",
    trackButton: "Show my order",
    orderNotFound: "No order matches this number and phone.",
    orderedOn: "Ordered on",
    continueShopping: "Continue shopping",
    deliveryCode: "Delivery code",
    deliveryCodeHint: "Give it to the courier when you receive your parcel",
    
    // Footer
    about: "About",
    contact: "Contact",
    help: "Help",
    terms: "Terms",
    privacy: "Privacy",
    followUs: "Follow Us",
    newsletter: "Newsletter",
    subscribe: "Subscribe",
    footerText: "Nengoo - Your trusted Cameroonian marketplace since 2025",
    
    // Authentication
    login: "Sign In",
    signup: "Sign Up",
    loginAsBuyer: "Sign In as Buyer",
    loginAsSeller: "Sign In as Seller",
    buyerLogin: "Buyer Login",
    sellerLogin: "Seller Login",
    whatsappNumber: "WhatsApp Number",
    enterWhatsApp: "Enter your WhatsApp number",
    selectCategories: "Select categories",
    businessName: "Business Name",
    selectCity: "Choose your city",
    signupAsSeller: "Seller Registration",
    signupAsBuyer: "Buyer Registration",
createAccount: "Create Account",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    pendingApproval: "Pending Approval",
    approvalMessage: "Your seller registration request has been submitted. You will receive a WhatsApp confirmation once your account is approved by the administrator.",
    backToHome: "Back to Home",
    logout: "Logout",
    welcomeBack: "Welcome Back",

    // Homepage (redesign)
    heroTitle: "Cameroon's sellers, gathered in one market",
    heroText: "Browse their products, add them to your cart or message the seller directly on WhatsApp.",
    browseCatalog: "Browse the catalog",
    pickupPoints: "Pickup points",
    shopByCategory: "Shop by category",
    allProducts: "All products",
    productCount: (n) => `${n} product${n > 1 ? 's' : ''}`,
    newBadge: "New",
    whatsappSeller: "WhatsApp",
    privacyPolicy: "Privacy policy",
    deleteAccount: "Delete my account",
    rightsReserved: "All rights reserved.",
    noProducts: "No products yet",
    noProductsText: "Sellers are adding their items. Come back soon or browse the catalog.",
    loadingProducts: "Loading products…",

    // Catalog
    catalogTitle: "Catalog",
    allCategories: "All",
    subcategories: "Subcategories",
    allOf: (name) => `All ${name}`,
    filters: "Filters",
    sortLabel: "Sort by",
    sortRecent: "Newest",
    sortName: "Name (A → Z)",
    sortPriceLow: "Price: low to high",
    sortPriceHigh: "Price: high to low",
    maxPrice: "Maximum price",
    upTo: (p) => `Up to ${p}`,
    resetFilters: "Reset filters",
    noMatch: "No products match these filters",
    noMatchText: "Raise the maximum price or pick another category.",
    loadError: "Products could not be loaded. Check your connection, then try again.",
    retry: "Try again",

    // Pickup points
    pickupIntro: "Have your order delivered to a pickup point near you, then collect it during its opening hours.",
    howItWorks: "How it works",
    pickupSteps: [
      "Choose a pickup point when you place your order.",
      "The seller drops your item off at that point.",
      "You are notified as soon as the parcel arrives.",
      "Collect it during opening hours."
    ],
    allCities: "All cities",
    managedBy: (n) => `Run by ${n}`,
    call: "Call",
    directions: "Directions",
    pickupCount: (n) => `${n} pickup point${n > 1 ? 's' : ''}`,
    pickupEmpty: "No pickup points yet",
    pickupEmptyText: "Pickup points are coming soon. Meanwhile, choose home delivery when you check out.",
    pickupError: "Pickup points could not be loaded. Check your connection, then try again.",
    
    // Product page
    soldBy: "Sold by",
    contactWhatsApp: "Contact on WhatsApp",
    sendMessage: "Send a message",
    messageTo: (n) => `Write to ${n}`,
    messagePlaceholder: "Your message to the seller…",
    cancel: "Cancel",
    send: "Send",
    share: "Share",
    reviewsTitle: "Customer reviews",
    reviewsCount: (n) => `${n} review${n > 1 ? 's' : ''}`,
    noReviews: "No reviews for this product yet.",
    leaveReview: "Write a review",
    yourRating: "Your rating",
    yourComment: "Your comment",
    submitReview: "Post review",
    alreadyReviewed: "You have already reviewed this product.",
    relatedProducts: "In the same category",
    productNotFound: "This product does not exist or is no longer for sale",
    productNotFoundText: "The seller may have removed it. Browse the catalog to find a similar item.",
    photoOf: (i) => `Photo ${i}`,
    zoomPhoto: "Enlarge photo"
  }
};
